/// <reference path='../../interfaces/interfaces.d.ts' />

import {throws} from "assert";

'use strict';

class DropzoneInputDirective {
    public restrict = 'E';
    public scope;
    public times: String[] = [];
    public currentValue;

    public template;

    constructor() {
        this.restrict = 'E';
        this.scope = {
            onFileAdded: '&',
            onChange: '&',
            fileModel: '=',
        };

        this.template = `
            <input id=inputFile class="import-dropzone" type="file" name='file' data-file-model='fileModel' onchange="onChange()">
        `;
    }

    public link($scope: any, $element: any, attrs: any): any {
        var that = this;
        var config = {
            url: "#",
            clickable: ".file-selector, #file-form",
            createImageThumbnails: false,
            accept: function (file, done) {
                $scope.onFileAdded({file: file});
                $scope.$apply();
            }
        };

        var myDropzone = new Dropzone($element[0], config);
    }

    public static DirectiveFn(): DropzoneInputDirective {
        return new DropzoneInputDirective();
    }
}

angular.module('beneple.global').directive('dropzoneInputAll', DropzoneInputDirective.DirectiveFn);

/**
 * <div id="file-form" class="dz-clickable dropzone"><div id="file-dnd"><input id="inputFile" type="file" name="file" accept=".csv,.xls,.xlsx" data-file-model="C.fileInfo.file" onchange="angular.element(this).scope().C.fileChange()" class="import-dropzone"><!--dropzone-input.import-dropzone.dropzone#inputFile(on-file-added="C.updateFileData(file)")--><div class="col-xs-offset-4"><!-- ngIf: !C.fileInfo.file --><p data-ng-if="!C.fileInfo.file" class="ng-scope"><b>Drag and drop a file or click to select a file</b></p><!-- end ngIf: !C.fileInfo.file --></div></div></div>
 * <div id="file-form" class="dropzone dz-clickable"><div id="file-dnd"><!--input#inputFile.import-dropzone(type="file", name='file', accept=".csv,.xls,.xlsx", data-file-model='C.fileInfo.file', onchange="angular.element(this).scope().C.fileChange()")--><dropzone-input id="inputFile" on-file-added="C.updateFileData(file)" class="import-dropzone dropzone ng-isolate-scope">
 *             <input id="inputFile" class="import-dropzone dropzone" type="file" name="file" accept=".csv,.xls,.xlsx" data-file-model="C.fileInfo.file" onchange="C.fileChange()">
 *         <div class="dz-default dz-message"><span>Drop files here to upload</span></div></dropzone-input><div class="col-xs-offset-4"><!-- ngIf: !C.fileInfo.file --><p data-ng-if="!C.fileInfo.file" class="ng-scope"><b>Drag and drop a file or click to select a file</b></p><!-- end ngIf: !C.fileInfo.file --></div></div></div>
 */


// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/dropzone_input_all.directive.ts